import React, { FunctionComponent } from 'react';

interface GridInterface {
    extraClass?: string;
}

export const Grid: FunctionComponent<GridInterface> = ({ extraClass = '', children }) => (
    <div className={`o-grid ${extraClass}`}>{children}</div>
);
